import { TextField, InputAdornment, IconButton } from "@mui/material";
import React from "react";

import type { TextInputProps } from "./interfaces";

const Text: React.FC<TextInputProps> = ({
  id,
  disabled,
  label,
  placeholder,
  value,
  name,
  onChange,
  onIconClick,
  icon,
}) => {
  return (
        <TextField
          fullWidth
          id={id}
          disabled={disabled}
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          size="small"
          sx={{
            backgroundColor: "#f1f1f1",
            width: "100%",
             "& .MuiFormControl-root": {
              width: "100%",
            },
            "& .MuiOutlinedInput-root": {
              height: "40px",

              "& fieldset": {
                borderColor: "#000",

              },
              "&:hover fieldset": {
                borderColor: "#76A6C2" ,
              },
              "&.Mui-focused fieldset": {
                borderColor: "#76A6C2" ,
              },
            },
            "& .MuiInputBase-input": {
              color: "#000",
              height: "40px",
              padding: "0 14px 0 30px",
              display: "flex",
              alignItems: "center",
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#d5d5d5",
              opacity: 1,
            },
            "& input:-webkit-autofill": {
              WebkitBoxShadow: `0 0 0 1000px #f1f1f1 inset`,
              WebkitTextFillColor: "#000",
              borderColor: "#76A6C2" ,
              paddingLeft: '30px'
            },
          }}
          InputProps={{
            endAdornment: icon ? (
              <InputAdornment position="end">
                <IconButton onClick={onIconClick}>
                  {icon}
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />
  );
};

export default Text;
